<template>
  <div>
    <v-row
      align="center"
      justify="center"
      class="d-flex-column"
    >
      <v-col
        md="5"
        cols="12"
      >
        <v-menu
          ref="menu"
          v-model="isMenuOpen"
          :closeOnContentClick="dateRange.length === 2"
          transition="scale-transition"
          offsetY
          minWidth="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeText"
              :label="$t('generic.dateRange')"
              prependInnerIcon="event"
              readonly
              outlined
              :hideDetails="true"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="dateRange"
            range
            :max="$utils.getTomorrowDate()"
            :landscape="$vuetify.breakpoint.mdAndUp"
            :disabled="loadingCSV"
            :locale="datePickerLocales[$store.getters.lang]"
            color="#26384B"
          />
        </v-menu>
      </v-col>
      <v-col
        md="auto"
        cols="12"
      >
        <v-btn
          style="background-color: #EF4135; color: white; text-transform: capitalize"
          :disabled="disableBtn"
          @click="exportSiteAnalysisCSV"
        >
          {{ $t('csv.exportCsv') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _datePickerLocales from '@/locales/date-picker-locales';
import moment from 'moment';

export default {
    name: 'ExportAnalysisMeasure',
    data() {
        return {
            uniqueLinesComponents: [],
            dateRange: [],
            loadingCSV: false,
            isMenuOpen: false,
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
        ]),
        dateRangeText() {
            return this.dateRange
                .map(date => this.$options.filters.formatDate(date, 'L'))
                .join(' ~ ');
        },
        disableBtn() {
            return !!(this.dateRange.length < 2);
        },
        datePickerLocales() {
            return _datePickerLocales;
        },
    },
    methods: {
        async exportSiteAnalysisCSV() {
            this.loadingCSV = true;
            const startDate = moment(this.dateRange[0]).tz('utc').startOf('day').toISOString();
            const endDate = this.dateRange[1] ? moment(this.dateRange[1]).tz('utc').endOf('day').toISOString() : moment().tz('utc').endOf('day').toISOString();
            const { data } = await this.$rq.exportLabWOSample({
                startDate,
                endDate,
            });

            if (!data.length) {
                this.$toasted.global.toast_error({
                    message: this.$t('exportAnalysis.noResults'),
                });
            } else {
                const fileName = `labSamples_${startDate.split('T')[0]}_to_${endDate.split('T')[0]}.csv`;
                this.$utils.saveFileOnDisk(new Blob([data]), fileName);
            }

            this.loadingCSV = false;
        },
    },
};
</script>
